import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";

const ProgramHeader = ({ icon, descripion, type, title }) => {
  const { language } = React.useContext(ContextLanguage);

  return (
    <div>
      <div
        className={`flex items-center ${
          type === "My Wash" ? " gap-3 " : " gap-2 "
        }`}
      >
        {icon ? (
          <div
            className={`${
              (type === "My Shoes" && " mr-3") ||
              (type === "My Iron" && " mr-3")
            }  `}
          >
            {icon}
          </div>
        ) : (
          <div className=" w-11 md:w-w_75 h-11 md:h-[75px] "></div>
        )}

        <div
          style={{
            width: "90%",
          }}
          className={`${
            language === "TH"
              ? " text-base-th md:text-22-th font-NotoSansThai"
              : " text-base md:text-22 font-Poppins"
          } font-bold text-laudry-gray-200 leading-8 md:leadding-8  `}
        >
          {/* {(type === "My Wash" && "My Wash") ||
            (type === "My Shoes" && "My Shoes") ||
            (type === "My Iron" && "My Iron")} */}
          {title}
          <div
            className={` ${
              language === "TH"
                ? " text-xs-th md:text-base-th "
                : " text-xs md:text-base "
            } text-laundry-gray-100 font-normal leading-4 md:leading-6 ${
              language === "TH" ? "font-NotoSansThai" : "font-Poppins"
            } `}
          >
            {descripion}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramHeader;
